import {
  ConfigState,
  DefaultDateFormat,
  IConfigAction,
} from "../actions/types/configTypes";

const initialState: ConfigState = {
  modalEditing: { is: false, show: false, action: () => {} },
  pathname: "",
  dateFormat: DefaultDateFormat.default,
  resetFocus: false,
  isScanning: false,
  backupInputValueIfIsScanning: null,
};

export const configReducer = (
  state = initialState,
  action: IConfigAction<any>
): ConfigState => {
  switch (action.type) {
    case "CONFIG_EDITING":
      return {
        ...state,
        modalEditing: { ...state.modalEditing, ...action.payload },
      };
    case "CONFIG_PATHNAME":
      return {
        ...state,
        pathname: action.payload,
      };
    case "CONFIG_RESET_MODAL":
      return {
        ...state,
        modalEditing: initialState.modalEditing,
      };
    case "CONFIG_DEFAULT_DATE_FORMAT":
      return {
        ...state,
        dateFormat: action.payload,
      };
    case "CONFIG_FOCUSRESET_ON":
      return {
        ...state,
        resetFocus: true,
      };
    case "CONFIG_FOCUSRESET_OFF":
      return {
        ...state,
        resetFocus: false,
      };
    case "CONFIG_SET_IS_SCANNING":
      return {
        ...state,
        isScanning: action.payload,
      };
    case "CONFIG_BACKUP_INPUT_VALUE":
      return {
        ...state,
        backupInputValueIfIsScanning: action.payload,
      };
    default:
      return state;
  }
};

export default configReducer;
